//@ts-check

import React, { useEffect, useRef, useState } from 'react';

// @ts-ignore
import stylesCourse from 'styles/Course.module.scss';

import FormatContentArrow from 'modules/Course/Unit/components/FormatContentArrow';
// @ts-ignore
import useWindowSize from 'hooks/useWindowSize';
import { parseHtml } from 'helpers';
// @ts-ignore

const DragDropMarking = ({ asnwer, question }) => {
  const [width] = useWindowSize();

  const [listHeight, setListHeight] = useState({
    quesList: [],
    ansList: [],
    quesAnsCommonHeight: [],
  });

  const QusElementRef = useRef(null);
  const AnsElementRef = useRef(null);

  // get quiz element height
  useEffect(() => {
    if (!QusElementRef?.current) return null;
    const calculateHeights = () => {
      const newArray = Array.from(QusElementRef.current.children).map(
        (item, index) => item.clientHeight,
      );
      setListHeight((preVal) => ({
        ...preVal,
        quesList: [...newArray],
      }));
    };
    const images = document.querySelectorAll('img');
    let loadedImagesCount = 0;

    const handleImageLoad = () => {
      loadedImagesCount += 1;
      if (loadedImagesCount === images.length) {
        calculateHeights();
      }
    };
    images.forEach((img) => {
      if (img.complete) {
        handleImageLoad();
      } else {
        img.addEventListener('load', handleImageLoad);
      }
    });

    // Cleanup event listeners
    return () => {
      images.forEach((img) => {
        img.removeEventListener('load', handleImageLoad);
      });
    };
  }, [QusElementRef?.current]);

  // get ans element height
  useEffect(() => {
    if (!AnsElementRef?.current) return null;
    const calculateHeights = () => {
      const newArray = Array.from(AnsElementRef.current.children).map(
        (item, index) => item.clientHeight,
      );

      setListHeight((preVal) => ({
        ...preVal,
        ansList: [...newArray],
      }));
    };
    const images = document.querySelectorAll('img');
    let loadedImagesCount = 0;

    const handleImageLoad = () => {
      loadedImagesCount += 1;
      if (loadedImagesCount === images.length) {
        calculateHeights();
      }
    };
    images.forEach((img) => {
      if (img.complete) {
        handleImageLoad();
      } else {
        img.addEventListener('load', handleImageLoad);
      }
    });

    // Cleanup event listeners
    return () => {
      images.forEach((img) => {
        img.removeEventListener('load', handleImageLoad);
      });
    };
  }, [AnsElementRef?.current]);

  //  get common height from quiz{quiz, ans}
  useEffect(() => {
    if (listHeight?.quesList.length === 0 && listHeight?.ansList.length === 0)
      return null;
    const filterHeight = listHeight.ansList.map((item, index) =>
      listHeight.quesList[index] >= item ? listHeight.quesList[index] : item,
    );
    setListHeight((preVal) => ({
      ...preVal,
      quesAnsCommonHeight: [...filterHeight],
    }));
  }, [listHeight.ansList, listHeight.quesList]);

  return (
    <>
      <div className={`d-flex mb-1 `}>
        <div ref={QusElementRef}>
          <FormatContent
            list={question}
            commonHeight={listHeight.quesAnsCommonHeight}
          />
        </div>
        <div>
          <FormatContentArrow
            index={question?.length}
            commonHeight={listHeight.quesAnsCommonHeight}
          />
        </div>
        <div ref={AnsElementRef}>
          <FormatContent
            list={asnwer}
            commonHeight={listHeight.quesAnsCommonHeight}
            isYourans
          />
        </div>
      </div>
    </>
  );
};

export default DragDropMarking;

/**
 *
 * @param {{list: {answer: string, content: string}[], commonHeight: any[], isYourans?: boolean}} param0
 * @returns {JSX.Element}
 */

const FormatContent = ({ list, commonHeight, isYourans }) => {
  return (
    <>
      {list?.map((item, index) => (
        <div key={index}>
          <div
            className={
              ` flexRow ${stylesCourse['item-section-normal']}` +
              ` ${stylesCourse['item-section-enabled']}` +
              ` ${stylesCourse['animation-height']}`
            }
            style={{
              maxWidth: '40rem',
              height: !commonHeight?.length ? '100%' : commonHeight[index],

              // @ts-ignore
              '--labelcolor': '#c1c9d4',
            }}
          >
            <span
              className={`w-100 px-md-2 px-05 py-05 ${stylesCourse['item-unit-label']}`}
            >
              <span
                className={`drag-overflow-image ${stylesCourse['item-unit-title']}`}
              >
                {parseHtml((isYourans ? item?.answer : item?.content) || item)}
              </span>
            </span>
          </div>
        </div>
      ))}
    </>
  );
};
